import { AuthProvider as Provider } from "hooks/auth";

const AuthProvider = ({ signOut, user, children }) => {
  return <Provider>{children}</Provider>;
};

export default AuthProvider;
